import {html} from "@isceco/widget-library2/external/lit";
import '@isceco/widget-library2/basic-elements/TextInput/TextInput'
import InputColumn from '@isceco/widget-library2/basic-elements/List/column/InputColumn';
import AddRemoveColumn from '@isceco/widget-library2/basic-elements/List/column/AddRemoveColumn';

export default class AdministrationEditColumns {

  static getColumns(i18n) {
    return [
      AdministrationEditColumns.EMAIL_COLUMN(i18n),
      new AddRemoveColumn()
    ]
  }

  static EMAIL_COLUMN(i18n) {
    return new InputColumn({
      key: 'email',
      text: `${i18n.translate('administration.edit.email')}`,
      render: (inheritedI18n, cell, value) => html`
        <isceco-text-input name="email"
                           value="${value instanceof Object ? '' : value}"
                           required
                           maxlength="255"
        ></isceco-text-input>
      `
    })
  }

}
